import React from 'react';
import { Navigate } from 'react-router-dom';

export const getUserRole = () => localStorage.getItem('role');

export const ProtectedRoute = ({ element, allowedRoles }) => {
  const userRole = getUserRole();
  if (allowedRoles.includes(userRole)) {
    return element;
  }
  return <Navigate to="/" />;
};
